<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <UserTabs
        :user="user"
        v-model="currentTab"
        @delete="deleteUser"
        @edit="editUser"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="user">
          <UserDetails :user="user"/>
        </v-tab-item>
        <v-tab-item value="group">
          <UserGroups :user="user"/>
        </v-tab-item>
        <v-tab-item value="permission">
          <UserPermissions :user="user"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { usersService } from '../../utils/services/users.service';
  import UserTabs from '../../components/app/Users/UserTabs';
  import UserDetails from '../../components/app/Users/UserDetails';
  import UserPermissions from '../../components/app/Users/UserPermissions';
  import UserGroups from '../../components/app/Users/UserGroups';
  import UserModal from '../../components/modals/UserModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'UserShow',
    components: {
        Loader,
        UserTabs,
        UserDetails,
        UserPermissions,
        UserGroups,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        user: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchUser(id) {
        return usersService.get(id)
        .then(response => {
          this.user = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteUser() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return usersService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(this.routeName.USER);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editUser() {
          this.showModal({
              component: UserModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('USER'),
                onSave: (
                  form,
                  error,
                ) => usersService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchUser(this.id);
      this.loading = false;
    },
  };
</script>
